import React from "react";

const RefundPolicy = () => {
  return (
    <div className="policy-container">
      <h1>Refund Policy</h1>
      <p>
        At <strong>Radical Sports India</strong>, we are committed to offering a safe, structured, and disciplined learning experience. Please carefully review our refund policy before enrolling in any of our skating programs or services.
      </p>

      <h2>1. No Refund Policy</h2>
      <p>
        All fees paid to Radical Sports India are <strong>non-refundable</strong> under any circumstances. This includes but is not limited to:
      </p>
      <ul>
        <li>Absence of the student due to illness, vacation, exams, or personal reasons.</li>
        <li>Cancellation of sessions due to weather conditions, public holidays, or emergencies.</li>
        <li>Discontinuation or withdrawal from the program after enrollment.</li>
      </ul>

      <h2>2. Missed Sessions</h2>
      <p>
        Refunds or makeup classes will not be provided for sessions missed by the student. However, long-term absences may be reviewed for potential rescheduling, based on availability and academy discretion.
      </p>

      <h2>3. Mandatory Gear Requirement</h2>
      <p>
        All skaters must attend training sessions with complete safety gear including a helmet, guard set, and the official academy uniform. No refunds will be issued due to absence related to missing gear.
      </p>

      <h2>4. Session Cancellations</h2>
      <p>
        If a session is canceled by the academy due to unforeseen circumstances, we will attempt to notify students in advance. Such cancellations will not be eligible for refunds but may be compensated by rescheduling when possible.
      </p>

      <h2>5. Late Fee & Social Support</h2>
      <p>
        A late fee of ₹200 will apply if fees are not cleared by the 10th of each month. This amount contributes towards supporting underprivileged children through our skating outreach initiatives.
      </p>

      <h2>6. Contact Us</h2>
      <p>
        For any questions or concerns regarding this policy, feel free to reach out to us:
      </p>
      <ul>
        <li><strong>Email:</strong> Info@radicalsportsindia.com</li>
        <li><strong>Phone:</strong> +91 76546 4545</li>
        <li><strong>Address:</strong> Radical Sports Academy, 2nd Floor, Ajanta Shopping Centre, 225, Daftary Road, opp. Surbhi Sweets, near Railway Station, Malad East, Mumbai, Maharashtra 400097</li>
      </ul>
    </div>
  );
};

export default RefundPolicy;
